import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryEntityFields(params) {
  return request('/dynamicEntityField/paged', {
    params: toQuery(params),
  });
}

export async function queryEntityActivate(id, state) {
  return request.post(`/dynamicEntity/activate/${id}/${state}`, {});
}
